import { PartialRecord, TupleToUnion } from "@base/util/TypeUtil";
import { ConfiguratorType, OrderType } from "@biz/Definitions";
import { ILayerData } from "@biz/definitions/LayerDefinitions";
import { IPowderCoatingProduct } from "@biz/definitions/PowderCoatingDefinitions";
import { ProductVersion } from "@biz/definitions/ProductVersion";
import { EditorRawState } from "@biz/draftEditor/EditorDefinitions";
import { IShoppingList } from "@biz/models/ShoppingListDefinitions";

export type ShipmentType = "post" | "spedition";
export type MeasureVisibility = "net" | "netGround" | "ground" | "bottom" | "bottomSandy" | "bottomSandyArea" | "bottomSandyOBB" | "bottomSandyAreaOBB" | "mount" | "sailMount" | "mountGround" | "groundCS" | "poleLength" | "poleHeights" | "mountPoint" | "distOut" | "distIn" | "coilUp" | "raff" | "netArea" | "axleMount" | "axleTubeBrutto" | "axleTubeNetto" | "shop";

export const featureLevels = ["user", "dealer", "soliday"] as const;
export type FeatureLevel = TupleToUnion<typeof featureLevels>;

export type IEditorText = { type: "html", value: string } | { type: "raw", value: EditorRawState };


export interface IItemData extends ILayerData {
  id: string;
  version: ProductVersion;
  buildTime: number
}
export interface IGroupData extends ILayerData {
  id: string;
  itemType: "group";
  children: string[];
}



export interface INotesAndFiles {
  notes?: IEditorText;
  files?: string[];
}


export interface IProductData extends IItemData, INotesAndFiles {
  count: number;
  shoppingList: IShoppingList;
  orderType: OrderType | undefined;
  powderCoating?: IPowderCoatingProduct;
  measures?: PartialRecord<MeasureVisibility, boolean>;
  sourceConfigurator?: ConfiguratorType;
  featureLevel: FeatureLevel;
}

